import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {DataResponse} from '../../../network/service/data.response';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {RequestType} from '../../../enums/request.type';
import {ListResponse} from '../../../network/service/list.response';
import {Params} from '@angular/router';
import {Config} from '../../../common/config';
import {RouteUtil} from '../../../util/route.util';

@Component({
  selector: 'app-add-or-update-services',
  standalone: false,
  templateUrl: './add-or-update-services.component.html',
  styleUrl: './add-or-update-services.component.scss'
})
export class AddOrUpdateServicesComponent extends BaseComponent implements OnInit {
  productId?: string;
  imageFiles?: any;
  images?: string[];
  title?: any;
  standardCode?: any;
  price?: string;
  newPrice?: string;
  maxCapacity?: number;
  orderedCount?: string;
  rate?: string;
  isActive?: boolean;
  description: string = '';
  startDate?: string;
  endDate?: string;
  categoryId?: string;
  tagId?: string;
  service?: any;
  serviceId?: any;

  constructor(injector: Injector) {
    super(injector);
    this.activatedRoute.params.subscribe((params: Params) => {
      if (params['ServiceId'] && params['ServiceId'] !== '') {
        this.serviceId = params['ServiceId'];
      }
    });
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    if (this.serviceId) {
      this.serviceApi.getServices(this.tableProperties.offset, this.tableProperties.limit, 'Category,ServicePrices', RequestType.ONE, undefined, {
        Filter: {
          Values: [{
            Field: 'ServiceId',
            Type: 'EQ',
            Value: this.serviceId
          }]
        },
      }).subscribe((res: ListResponse<any>) => {
        if (res.success) {
          this.service = res.data;
          this.onDataPrepared();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    }
  }

  onDataPrepared() {
    this.title = this.service.Title;
    this.standardCode = this.service.StandardCode;
    this.categoryId = this.service.CategoryId;
    this.productId = this.service.ProductId;
    this.images = this.service.Images;
    if (this.images) {
      this.imageFiles = this.images.map((image: string) => {
        return {
          name: image
        };
      });
    }
    this.price = this.service.ServicePrices[0].Price;
    this.newPrice = this.service.ServicePrices[0].NewPrice;
    this.maxCapacity = this.service.ServicePrices[0].MaxCapacity;
    this.description = this.service.Description;
    this.orderedCount = this.service.ServicePrices[0].OrderedCount;
    this.startDate = this.service.ServicePrices[0].StartTime;
    this.endDate = this.service.ServicePrices[0].EndTime;
    this.isActive = this.service.IsActive;
  }

  upload(index: number, onFinished: any) {
    if (!this.imageFiles || this.imageFiles.length === 0) {
      return onFinished();
    }
    if (index >= this.imageFiles!.length) {
      onFinished();
    } else {
      if (this.imageFiles[index] instanceof File) {
        let formData = new FormData();
        formData.append('File', this.imageFiles[index]);
        this.serviceApi.upload(formData).subscribe((res: DataResponse<any>) => {
          if (res.data) {
            this.images!.push(res.data.dataValues.FileId);
            this.upload(++index, onFinished);
          } else {
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          }
        });
      } else {
        this.images!.push(this.imageFiles[index].name);
        this.upload(++index, onFinished);
      }
    }
  }

  onSubmitClicked() {
    if (this.isRequiredFieldsFilled(this.price, this.maxCapacity)) {
      this.images = [];
      this.upload(0, () => {
        (this.serviceId !== undefined ? this.serviceApi.updateServices(this.serviceId, {
          Title: this.title,
          StandardCode: this.standardCode,
          Images: this.images,
          Price: this.price,
          NewPrice: this.newPrice,
          MaxCapacity: this.maxCapacity,
          Description: this.description,
          CategoryId: this.categoryId,
          TagIds: this.tagId,
          StartTime: this.startDate,
          EndTime: this.endDate,
          IsActive: this.isActive ? this.isActive : false,
          BusinessId: Config.selectedBusinessId,
        }) : this.serviceApi.createServices({
          Title: this.title,
          StandardCode: this.standardCode,
          Images: this.images,
          Price: this.price,
          NewPrice: this.newPrice,
          MaxCapacity: this.maxCapacity,
          Description: this.description,
          CategoryId: this.categoryId,
          TagIds: this.tagId,
          StartTime: this.startDate,
          EndTime: this.endDate,
          IsActive: this.isActive ? this.isActive : false,
          BusinessId: Config.selectedBusinessId,
        })).subscribe((res: DataResponse<any>) => {
          if (res.success) {
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
            this.onCancelClicked();
          } else {
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          }
        });
      });
    }
  }

  onCancelClicked() {
    this.router.navigate([RouteUtil.DASHBOARD_MODULE, RouteUtil.SERVICES_COMPONENT]).then();
  }
}
